
    import * as React from 'react';

    const Clock20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Clock_20_svg__Icons/Clock/20" stroke="none" strokeWidth={1} fillRule="evenodd"><g transform="translate(1.000000, 1.000000)" fillRule="nonzero"><path d="M9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 C4.02943725,0 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 Z M9,17 C4.581722,17 1,13.418278 1,9 C1,4.581722 4.581722,1 9,1 C13.418278,1 17,4.581722 17,9 C17,13.418278 13.418278,17 9,17 Z" id="Clock_20_svg__Oval" /><path d="M8.9,4 L8.9,9.1 L14,9.1 L14,10 L8,10 L8,4 L8.9,4 Z" id="Clock_20_svg__Combined-Shape" /></g></g></svg>
        </div>
      );
    };

    Clock20.displayName = 'Clock20';

    export default Clock20;
  